module.exports = __webpack_public_path__ + "img/warabee1.218eeb4d.png";